module.exports = __webpack_public_path__ + "img/sign_220250565_1.70ca100e.png";